export const REDUCER_NAME = "commissionSlice";

export interface iCommissionResponse {
  transactionId: string;
  transactionCode: string;
  amount: string;
  purchaseDate: string;
  buyerId: string;
  buyerName: string;
  buyerEmail: string;
  buyerPhone: string;
  themeId: string;
  themeTitle: string;
  themePrice: string;
  category: string;
  percentage: string;
  paymentMode: string;
  paymentStatus: string;
}

export interface iCommissionDTO {
  category?: string;
  percentage?: number | string;
  title?: string;
  themeId?: string;
}

export interface iCommissionState {
  commissionList: iCommissionResponse[];
  isLoading: boolean;
  errorMessage: string | null;
}